import { ChangeEmailForm } from '../../forms/change_email_form';

export default class View {
	constructor() {
        // stop if wrong page!
        if (!document.querySelector('.change-email-container')) {
          return;
        }
        let container = document.querySelector('.changeemail-container');
        let form = document.querySelector('.changeemail-form');
        new ChangeEmailForm(form, container, this);
    }
}
